import React from "react";
import Content2025 from "../content2025";
import Footer from "../Footer";

function Productions2025() {
  return (
    <div className="page-wrapper">
      <Content2025 />
      <br></br>
      <Footer />
    </div>
  );
}

export default Productions2025;
